import { CToaster } from "@appcues/component-library";

export default CToaster.create();
